import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../extra/Table";
import Iconb from "../../extra/Iconb";
import { connect, useDispatch, useSelector } from "react-redux";
import { getUser, userIsBlock, deleteUser } from "../../store/user/user.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Searching from "../../extra/Searching";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import "react-loading-skeleton/dist/skeleton.css";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { warningForText } from "../../../util/Alert";


const User = (props) => {
  const [size, setSize] = useState(100);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const { user, totalUser } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getUser(currentPage, size, search))
  }, [dispatch, currentPage, size, search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(user);
  }, [user]);

  // pagination
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const val = parseInt(event, 10) || 10;
    setRowsPerPage(val);
    setSize(val);
    setCurrentPage(1);
  };

  // Self-contained server pagination (the shared <Pagination/> server mode
  // never renders numbered buttons, making 1000+ pages unusable).
  const totalPages = Math.max(1, Math.ceil((totalUser || 0) / rowsPerPage));
  const rangeStart = totalUser === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const rangeEnd = Math.min(currentPage * rowsPerPage, totalUser || 0);
  const goToPage = (p) => {
    const clamped = Math.max(1, Math.min(totalPages, parseInt(p, 10) || 1));
    setCurrentPage(clamped);
  };
  const pageWindow = () => {
    const win = 5;
    let start = Math.max(1, currentPage - Math.floor(win / 2));
    let end = Math.min(totalPages, start + win - 1);
    start = Math.max(1, end - win + 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const handleOpen = (id) => {
    navigate("/admin/UserProfile", {
      state: id,
    });
  };

  const handleClick = (userDetails) => {
    props.userIsBlock(
      userDetails,
      userDetails?.isBlock === true ? false : true
    );
  };

  // searching
  const handleFilterData = (searchValue) => {
    setSearch(searchValue);
    setCurrentPage(1);
  };

  const handleDelete = (row) => {
    const data = warningForText(
      `This will permanently delete ${row.firstName} ${row.lastName} and all their orders, addresses, and related data. This action cannot be undone!`
    );
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteUser(row._id);
        }
      })
      .catch((err) => console.log(err));
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </span>
      ),
    },
    {
      Header: "User",
      body: "firstName",
      Cell: ({ row }) => (
        <div
          className="d-flex"
          onClick={() => handleOpen(row._id)}
          style={{ cursor: "pointer" }}
        >
          <div className="position-relative">
            {loading ? (
              <>
                <Skeleton
                  height={42}
                  width={42}
                  style={{ borderRadius: "90px" }}
                  className="StripeElement "
                  baseColor={colors?.baseColor}
                  highlightColor={colors?.highlightColor}

                />
              </>
            ) : (
              <>
                <img
                  src={row?.image}
                  height={45}
                  width={45}
                  alt=""
                  style={{ borderRadius: "90px" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/dummy.png";
                  }}
                />

              </>
            )}
          </div>
          <span className="fw-normal ms-3 boxCenter text-start ">
            <b className="fw-normal text-capitalize text-white">
              {row.firstName + " " + row.lastName}
            </b>
          </span>
        </div>
      ),
      sorting: false,    //you can on if sorting need
    },

    {
      Header: "Contact",
      body: "email",
      sorting: false,
      Cell: ({ row }) => (
        <div className="">
          <span className="text-white fw-normal">{row.email ? row.email : "-"}</span>
          <p className="mb-0 text-white fw-normal">{row.mobileNumber ? row.mobileNumber : "-"}</p>
        </div>
      ),
    },

    {
      Header: "Unique Id", body: "uniqueId", sorting: false,

      Cell: ({ row }) => (
        <p className="mb-0 text-white">
          {row.uniqueId ? row.uniqueId : "-"}
        </p>
      ),
    },
    {
      Header: "Country",
      body: "location",
      Cell: ({ row }) => (
        <p className="mb-0 text-uppercase text-white">
          {row.location ? row.location : "-"}
        </p>
      ),
    },
    {
      Header: "Total Order",
      body: "orderCount",
      Cell: ({ row }) => (
        <span
          className="mb-0 text-dark"
          style={{
            backgroundColor: "#c6e7ff",
            color: "#008df2",
            padding: "10px 15px",
            borderRadius: "5px",
          }}
        >
          {row.orderCount ? row.orderCount : 0}
        </span>
      ),
    },
    {
      Header: "Register Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white">{dayjs(row.date).format("DD MMM YYYY")}</span>
      ),
    },
    {
      Header: "Block",
      body: "isBlock",
      Cell: ({ row }) => (
        <div className="">

          <ToggleSwitch value={row.isBlock} onClick={() => handleClick(row)} disabled={row?.email === "erashoptest@gmail.com" && true} />
        </div>
      ),
    },

    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          type="button"
          newClass={` boxCenter   infobtn userBtn  `}
          btnIcon={<InfoOutlinedIcon sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "80px",
            margin: "auto",
            height: "38px",
            width: "38px",
            color: "#160d98",



          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleOpen(row._id)}
        />


      ),
    },
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<DeleteOutlineIcon sx={{ color: '#dc3545' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            padding: "0px"
          }}
          onClick={() => handleDelete(row)}
          disabled={row?.email === "erashoptest@gmail.com"}
        />
      ),
    },

    // add more columns as needed
  ];
  return (
    <>
      <div className="mainUserTable">
        <div className="userTable">
          <div className="col-12 headname">User Management </div>

          <div className="userMain">
            <div className="tableMain mt-2">
              <div className="userHeader primeHeader">
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-10">
                    <Searching
                      type={`server`}
                      data={user}
                      setData={setData}
                      column={data}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                      button={true}
                      setSearchValue={setSearch}
                      searchValue={search}
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                serverPerPage={rowsPerPage}
                serverPage={page}
                type={"server"}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 8,
                  padding: "14px 16px",
                  justifyContent: "flex-end",
                }}
              >
                <span style={{ fontSize: 13, color: "#1A1614", fontWeight: 600 }}>
                  Rows:
                </span>
                <select
                  value={rowsPerPage}
                  onChange={(e) => handleChangeRowsPerPage(e.target.value)}
                  style={{
                    padding: "6px 10px",
                    borderRadius: 8,
                    border: "1px solid #E8E1D3",
                    background: "#FFFDF7",
                    color: "#1A1614",
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                  {[25, 50, 100, 200].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>

                <span style={{ fontSize: 13, color: "#8A857F", margin: "0 6px" }}>
                  {rangeStart}-{rangeEnd} of {totalUser || 0}
                </span>

                {(() => {
                  const btn = (label, onClick, disabled, active) => (
                    <button
                      key={label + (active ? "-a" : "")}
                      disabled={disabled}
                      onClick={onClick}
                      style={{
                        minWidth: 34,
                        padding: "6px 10px",
                        borderRadius: 8,
                        border: "1px solid #E8E1D3",
                        background: active ? "#D4A129" : disabled ? "#F3F0E9" : "#fff",
                        color: active ? "#fff" : "#1A1614",
                        cursor: disabled ? "default" : "pointer",
                        fontSize: 13,
                        fontWeight: active ? 700 : 500,
                      }}
                    >
                      {label}
                    </button>
                  );
                  return (
                    <>
                      {btn("«", () => goToPage(1), currentPage <= 1)}
                      {btn("‹", () => goToPage(currentPage - 1), currentPage <= 1)}
                      {pageWindow().map((p) =>
                        btn(String(p), () => goToPage(p), false, p === currentPage)
                      )}
                      {btn("›", () => goToPage(currentPage + 1), currentPage >= totalPages)}
                      {btn("»", () => goToPage(totalPages), currentPage >= totalPages)}
                    </>
                  );
                })()}

                <span style={{ fontSize: 13, color: "#8A857F", marginLeft: 8 }}>
                  Page {currentPage}/{totalPages}
                </span>
                <input
                  type="number"
                  min={1}
                  max={totalPages}
                  placeholder="Go"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goToPage(e.target.value);
                      e.target.value = "";
                    }
                  }}
                  style={{
                    width: 64,
                    padding: "6px 8px",
                    borderRadius: 8,
                    border: "1px solid #E8E1D3",
                    background: "#FFFDF7",
                    color: "#1A1614",
                    fontSize: 13,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="userFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getUser, userIsBlock, deleteUser })(User);
